var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "divBox bill-type",
      class: _vm.isDrawer ? "mt0" : "",
      on: {
        click: function ($event) {
          $event.stopPropagation()
          return _vm.hideMembersPicker()
        },
      },
    },
    [
      _c(
        "el-card",
        {
          staticClass: "employees-card",
          class: _vm.isDrawer ? "no-border" : "normal-page",
        },
        [
          _c("oaFromBox", {
            attrs: {
              treeData: _vm.treeData,
              treeDefault: _vm.treeDefault,
              search: _vm.search,
              viewSearch: _vm.viewSearch,
              dropdownList: _vm.dropdownList,
              total: _vm.total,
              title: _vm.$route.meta.title,
              btnText: "新建任务",
            },
            on: {
              treeChange: _vm.treeChange,
              addDataFn: _vm.addProgram,
              dropdownFn: _vm.dropdownFn,
              confirmData: _vm.confirmData,
            },
          }),
          _vm._v(" "),
          _c("div", [
            _c(
              "div",
              { staticClass: "table mt10", on: { mouseleave: _vm.mouseLeave } },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.headerShow,
                        expression: "headerShow",
                      },
                    ],
                    staticClass: "table-header",
                  },
                  [
                    _c("div", { staticClass: "header-right" }, [
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.headerShow,
                              expression: "headerShow",
                            },
                          ],
                          staticClass: "header-left fz13",
                        },
                        [_vm._v("已选择" + _vm._s(_vm.ids.length) + "个工作项")]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        [
                          _c("span", { staticClass: "fz13" }, [
                            _vm._v("批量设置："),
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-select",
                            {
                              staticStyle: {
                                width: "100px",
                                "margin-right": "10px",
                              },
                              attrs: {
                                size: "small",
                                clearable: "",
                                placeholder: "项目",
                              },
                              on: {
                                clear: _vm.setValueNull,
                                change: _vm.handleContract,
                              },
                              model: {
                                value: _vm.formData.program_id,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "program_id", $$v)
                                },
                                expression: "formData.program_id",
                              },
                            },
                            _vm._l(_vm.projectList, function (item) {
                              return _c(
                                "el-option",
                                {
                                  key: item.value,
                                  attrs: {
                                    label: item.label,
                                    value: item.value,
                                  },
                                },
                                [
                                  _c("div", [
                                    _c("span", [_vm._v(_vm._s(item.label))]),
                                    _vm._v(" "),
                                    item.status == 1 || item.status == 2
                                      ? _c(
                                          "span",
                                          {
                                            class:
                                              item.status == 1
                                                ? "program-stop"
                                                : "program-close",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                item.status == 1
                                                  ? "已暂停"
                                                  : "已关闭"
                                              )
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]),
                                ]
                              )
                            }),
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-select",
                            {
                              staticStyle: {
                                width: "100px",
                                "margin-right": "10px",
                              },
                              attrs: {
                                size: "small",
                                filterable: "",
                                clearable: "",
                                disabled: !_vm.formData.program_id,
                                "collapse-tags": "",
                                placeholder: "版本",
                              },
                              model: {
                                value: _vm.formData.version_id,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "version_id", $$v)
                                },
                                expression: "formData.version_id",
                              },
                            },
                            _vm._l(_vm.programVersionList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-select",
                            {
                              staticStyle: {
                                width: "100px",
                                "margin-right": "10px",
                              },
                              attrs: {
                                size: "small",
                                filterable: "",
                                clearable: "",
                                placeholder: "负责人",
                                disabled: !_vm.formData.program_id,
                              },
                              model: {
                                value: _vm.formData.uid,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "uid", $$v)
                                },
                                expression: "formData.uid",
                              },
                            },
                            _vm._l(_vm.programMemberOptions, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-select",
                            {
                              staticStyle: {
                                width: "100px",
                                "margin-right": "10px",
                              },
                              attrs: {
                                size: "small",
                                filterable: "",
                                clearable: "",
                                "collapse-tags": "",
                                placeholder: "状态",
                              },
                              model: {
                                value: _vm.formData.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "status", $$v)
                                },
                                expression: "formData.status",
                              },
                            },
                            _vm._l(
                              _vm.selectData.statusOptions,
                              function (item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.label,
                                    value: item.value,
                                  },
                                })
                              }
                            ),
                            1
                          ),
                          _vm._v(" "),
                          _c("el-cascader", {
                            staticStyle: {
                              width: "100px",
                              "margin-right": "10px",
                            },
                            attrs: {
                              size: "small",
                              options: _vm.programOptions,
                              props: { checkStrictly: true },
                              "collapse-tags": "",
                              clearable: "",
                              placeholder: "父工作项",
                              disabled: !_vm.formData.program_id,
                            },
                            on: { change: _vm.handleRemove },
                            model: {
                              value: _vm.formData.path,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "path", $$v)
                              },
                              expression: "formData.path",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-date-picker", {
                            staticStyle: {
                              width: "130px",
                              "margin-right": "10px",
                            },
                            attrs: {
                              size: "small",
                              type: "date",
                              clearable: "",
                              format: "yyyy-MM-dd",
                              "value-format": "yyyy-MM-dd",
                              placeholder: "开始时间",
                            },
                            model: {
                              value: _vm.formData.start_date,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "start_date", $$v)
                              },
                              expression: "formData.start_date",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-date-picker", {
                            staticStyle: {
                              width: "130px",
                              "margin-right": "10px",
                            },
                            attrs: {
                              size: "small",
                              type: "date",
                              clearable: "",
                              format: "yyyy-MM-dd",
                              "value-format": "yyyy-MM-dd",
                              placeholder: "结束时间",
                              "picker-options": {
                                disabledDate: _vm.disabledEndDate,
                              },
                            },
                            model: {
                              value: _vm.formData.end_date,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "end_date", $$v)
                              },
                              expression: "formData.end_date",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary", size: "small" },
                              on: { click: _vm.submitEvt },
                            },
                            [_vm._v(" 确定 ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small" },
                              on: { click: _vm.deleteEvt },
                            },
                            [_vm._v(" 删除 ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "cancel",
                              on: { click: _vm.cancelEvt },
                            },
                            [_vm._v("取消")]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-table",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loading,
                        expression: "loading",
                      },
                    ],
                    ref: "tableData",
                    staticClass: "draggable-table",
                    class: _vm.treePaddingClass,
                    staticStyle: { width: "100%" },
                    attrs: {
                      data: _vm.tableData,
                      height: _vm.isDrawer
                        ? "calc(100vh - 340px)"
                        : _vm.tableHeight,
                      "row-key": "id",
                      "cell-class-name": "handle",
                      "default-expand-all": "",
                      "header-cell-style": { background: "#f7fbff" },
                    },
                    on: {
                      "selection-change": _vm.handleSelectionChange,
                      "cell-mouse-enter": _vm.handleMouseEnter,
                      "cell-mouse-leave": _vm.handleMouseLeave,
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: { type: "", width: "20", fixed: "" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm.hoveredRow === scope.$index
                                ? _c("i", {
                                    staticClass:
                                      "handle sort-handle iconfont icontuodong pointer",
                                  })
                                : _vm._e(),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _vm.headerShow
                      ? _c("el-table-column", {
                          attrs: { type: "selection", width: "55", fixed: "" },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "ident",
                        label: "任务编号",
                        type: "",
                        width: "120",
                        fixed: "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "span",
                                {
                                  staticClass: "ident copy pointer handle",
                                  attrs: {
                                    title: "点击复制工作项地址",
                                    "data-clipboard-text": _vm.identAddress(
                                      scope.row
                                    ),
                                  },
                                  on: { click: _vm.copy },
                                },
                                [_vm._v("#" + _vm._s(scope.row.ident))]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "name",
                        label: "任务名称",
                        "min-width": "320",
                        fixed: "",
                        "show-overflow-tooltip": "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.add
                                ? _c(
                                    "div",
                                    [
                                      _c("el-input", {
                                        ref: "addInput-" + scope.row.id,
                                        staticStyle: { width: "260px" },
                                        attrs: {
                                          placeholder:
                                            "请输入子任务名称(Enter保存)",
                                        },
                                        on: {
                                          blur: function ($event) {
                                            return _vm.handleBlur(scope.row)
                                          },
                                        },
                                        nativeOn: {
                                          keyup: function ($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            ) {
                                              return null
                                            }
                                            return _vm.handleEnter(scope.row, 1)
                                          },
                                        },
                                        model: {
                                          value: _vm.addName,
                                          callback: function ($$v) {
                                            _vm.addName = $$v
                                          },
                                          expression: "addName",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !scope.row.add
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "program-name",
                                      on: {
                                        mouseenter: function ($event) {
                                          return _vm.showIcon(scope.$index)
                                        },
                                        mouseleave: function ($event) {
                                          return _vm.hideIcon(scope.$index)
                                        },
                                      },
                                    },
                                    [
                                      !scope.row.edit
                                        ? _c(
                                            "el-tooltip",
                                            {
                                              staticClass: "item",
                                              attrs: { disabled: "" },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "pointer flex align-center",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.editProgram(
                                                        scope.row
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "iconfont icontask1",
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "task-name line1",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(scope.row.name)
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  attrs: { slot: "content" },
                                                  slot: "content",
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(scope.row.name)
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      scope.row.edit
                                        ? _c("el-input", {
                                            on: {
                                              blur: function ($event) {
                                                return _vm.putName(scope.row, 0)
                                              },
                                            },
                                            nativeOn: {
                                              keyup: function ($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                ) {
                                                  return null
                                                }
                                                return _vm.putName(scope.row, 1)
                                              },
                                            },
                                            model: {
                                              value: scope.row.name,
                                              callback: function ($$v) {
                                                _vm.$set(scope.row, "name", $$v)
                                              },
                                              expression: "scope.row.name",
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !scope.row.edit
                                        ? _c(
                                            "div",
                                            { staticClass: "icon-btn" },
                                            [
                                              _vm.iconVisible[scope.$index] &&
                                              scope.row.level !== 4
                                                ? _c(
                                                    "el-tooltip",
                                                    {
                                                      staticClass: "item",
                                                      attrs: {
                                                        effect: "dark",
                                                        content: "新建子工作项",
                                                        placement: "top",
                                                        "open-delay": 500,
                                                      },
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "iconfont icona-ziji1x pointer",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return _vm.addChild(
                                                              scope.row
                                                            )
                                                          },
                                                        },
                                                      }),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.iconVisible[scope.$index] &&
                                              scope.row.operate
                                                ? _c(
                                                    "el-tooltip",
                                                    {
                                                      staticClass: "item",
                                                      attrs: {
                                                        effect: "dark",
                                                        content: "编辑",
                                                        placement: "top",
                                                        "open-delay": 500,
                                                      },
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "iconfont iconbianji pointer",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.editChild(
                                                              scope.row.id
                                                            )
                                                          },
                                                        },
                                                      }),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "priority",
                        label: "优先级",
                        width: "100",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-dropdown",
                                {
                                  attrs: {
                                    trigger: "click",
                                    placement: "bottom",
                                  },
                                  on: {
                                    command: function ($event) {
                                      return _vm.putProgramTask(
                                        "priority",
                                        $event,
                                        scope.row.id
                                      )
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "el-dropdown-link pointer dack",
                                      on: {
                                        click: function ($event) {
                                          return _vm.isOperate(scope.row)
                                        },
                                      },
                                    },
                                    [
                                      scope.row.priority == 1
                                        ? _c(
                                            "el-tag",
                                            {
                                              attrs: {
                                                type: "danger",
                                                effect: "dark",
                                                size: "mini",
                                              },
                                            },
                                            [_vm._v("紧急")]
                                          )
                                        : scope.row.priority == 2
                                        ? _c(
                                            "el-tag",
                                            {
                                              attrs: {
                                                type: "warning",
                                                effect: "dark",
                                                size: "mini",
                                              },
                                            },
                                            [_vm._v("高")]
                                          )
                                        : scope.row.priority == 3
                                        ? _c(
                                            "el-tag",
                                            {
                                              attrs: {
                                                effect: "dark",
                                                size: "mini",
                                              },
                                            },
                                            [_vm._v("中")]
                                          )
                                        : scope.row.priority == 4
                                        ? _c(
                                            "el-tag",
                                            {
                                              attrs: {
                                                type: "success",
                                                effect: "dark",
                                                size: "mini",
                                              },
                                            },
                                            [_vm._v("低")]
                                          )
                                        : _c(
                                            "el-tag",
                                            {
                                              attrs: {
                                                type: "info",
                                                effect: "dark",
                                                size: "mini",
                                              },
                                            },
                                            [_vm._v("无优先级")]
                                          ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-dropdown-menu",
                                    {
                                      attrs: { slot: "dropdown" },
                                      slot: "dropdown",
                                    },
                                    [
                                      scope.row.operate
                                        ? _c(
                                            "div",
                                            { staticClass: "fixed-height" },
                                            _vm._l(
                                              _vm.selectData.priorityOptions,
                                              function (item, index) {
                                                return _c(
                                                  "el-dropdown-item",
                                                  {
                                                    key: index,
                                                    attrs: {
                                                      command: item.value,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "el-tag",
                                                      {
                                                        attrs: {
                                                          effect: "dark",
                                                          size: "mini",
                                                          type:
                                                            item.value === 1
                                                              ? "danger"
                                                              : item.value === 2
                                                              ? "warning"
                                                              : item.value === 3
                                                              ? ""
                                                              : item.value === 4
                                                              ? "success"
                                                              : "info",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(item.label)
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            1
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { prop: "status", label: "状态", width: "80" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-dropdown",
                                {
                                  attrs: {
                                    trigger: "click",
                                    placement: "bottom",
                                  },
                                  on: {
                                    command: function ($event) {
                                      return _vm.putProgramTask(
                                        "status",
                                        $event,
                                        scope.row.id
                                      )
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "el-dropdown-link pointer status",
                                      on: {
                                        click: function ($event) {
                                          return _vm.isOperate(scope.row)
                                        },
                                      },
                                    },
                                    [
                                      scope.row.status == 0
                                        ? _c(
                                            "el-tag",
                                            {
                                              attrs: {
                                                type: "warning",
                                                effect: "plain",
                                                size: "mini",
                                              },
                                            },
                                            [_vm._v("未处理")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      scope.row.status == 1
                                        ? _c(
                                            "el-tag",
                                            {
                                              attrs: {
                                                effect: "plain",
                                                size: "mini",
                                              },
                                            },
                                            [_vm._v("进行中")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      scope.row.status == 2
                                        ? _c(
                                            "el-tag",
                                            {
                                              staticStyle: {
                                                color: "#f95c96",
                                                border: "1px solid #f95c96",
                                              },
                                              attrs: {
                                                type: "info",
                                                effect: "plain",
                                                size: "mini",
                                              },
                                            },
                                            [_vm._v("已解决")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      scope.row.status == 3
                                        ? _c(
                                            "el-tag",
                                            {
                                              attrs: {
                                                type: "success",
                                                effect: "plain",
                                                size: "mini",
                                              },
                                            },
                                            [_vm._v("已验收")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      scope.row.status == 4
                                        ? _c(
                                            "el-tag",
                                            {
                                              attrs: {
                                                type: "danger",
                                                effect: "plain",
                                                size: "mini",
                                              },
                                            },
                                            [_vm._v("已拒绝")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      scope.row.status == 5
                                        ? _c(
                                            "el-tag",
                                            {
                                              attrs: {
                                                type: "info",
                                                effect: "plain",
                                                size: "mini",
                                              },
                                            },
                                            [_vm._v("已关闭")]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-dropdown-menu",
                                    {
                                      attrs: { slot: "dropdown" },
                                      slot: "dropdown",
                                    },
                                    [
                                      scope.row.operate
                                        ? _c(
                                            "div",
                                            { staticClass: "fixed-height" },
                                            _vm._l(
                                              _vm.selectData.statusOptions,
                                              function (item, index) {
                                                return _c(
                                                  "el-dropdown-item",
                                                  {
                                                    key: index,
                                                    attrs: {
                                                      command: item.value,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "el-tag",
                                                      {
                                                        style: {
                                                          color:
                                                            item.value === 2
                                                              ? "#f95c96"
                                                              : "",
                                                          border:
                                                            item.value === 2
                                                              ? " 1px solid #f95c96"
                                                              : "",
                                                          background:
                                                            item.value === 2
                                                              ? "#fff"
                                                              : "",
                                                        },
                                                        attrs: {
                                                          effect: "plain",
                                                          size: "mini",
                                                          type:
                                                            item.value === 4
                                                              ? "danger"
                                                              : item.value === 0
                                                              ? "warning"
                                                              : item.value === 1
                                                              ? ""
                                                              : item.value === 3
                                                              ? "success"
                                                              : "info",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(item.label)
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            1
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { prop: "admins", label: "负责人", width: "120" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              !_vm.adminsVisible[scope.$index]
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "pointer",
                                      on: {
                                        click: function ($event) {
                                          return _vm.showAdmins(
                                            scope.row,
                                            scope.$index
                                          )
                                        },
                                      },
                                    },
                                    [
                                      scope.row.admins && scope.row.admins[0]
                                        ? _c("img", {
                                            staticClass: "img",
                                            attrs: {
                                              src: scope.row.admins[0]
                                                ? scope.row.admins[0].avatar
                                                : "",
                                              alt: "",
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      scope.row.admins
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                scope.row.admins[0]
                                                  ? scope.row.admins[0].name
                                                  : "- -"
                                              )
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]
                                  )
                                : _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        size: "small",
                                        clearable: "",
                                        placeholder: "负责人",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.chooseAdmins(
                                            scope.row,
                                            scope.$index
                                          )
                                        },
                                      },
                                      nativeOn: {
                                        click: function ($event) {
                                          return _vm.changeAdmins(
                                            scope.row.program_id,
                                            scope.$index
                                          )
                                        },
                                      },
                                      model: {
                                        value: _vm.adminsUid,
                                        callback: function ($$v) {
                                          _vm.adminsUid = $$v
                                        },
                                        expression: "adminsUid",
                                      },
                                    },
                                    _vm._l(
                                      _vm.programMemberOptions,
                                      function (item) {
                                        return _c("el-option", {
                                          key: item.id,
                                          attrs: {
                                            label: item.name,
                                            value: item.id,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "members",
                        label: "协作者",
                        "min-width": "180",
                        "show-overflow-tooltip": "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              !_vm.membersVisible[scope.$index]
                                ? _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        placement: "top",
                                        disabled:
                                          scope.row.members &&
                                          scope.row.members.length > 0
                                            ? false
                                            : true,
                                        "open-delay": 500,
                                      },
                                    },
                                    [
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "pointer line1 members-line",
                                            on: {
                                              click: function ($event) {
                                                return _vm.showMembers(
                                                  scope.row,
                                                  scope.$index
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._l(
                                              scope.row.members,
                                              function (item, index) {
                                                return _c(
                                                  "span",
                                                  { key: index },
                                                  [
                                                    _c("img", {
                                                      staticClass: "img",
                                                      attrs: {
                                                        src: item.avatar,
                                                      },
                                                    }),
                                                  ]
                                                )
                                              }
                                            ),
                                            _vm._v(" "),
                                            scope.row.members &&
                                            scope.row.members.length == 0
                                              ? _c("span", [_vm._v("- -")])
                                              : _vm._e(),
                                          ],
                                          2
                                        ),
                                      ],
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          attrs: { slot: "content" },
                                          slot: "content",
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "pointer tooltip" },
                                            [
                                              _vm._l(
                                                scope.row.members,
                                                function (item, index) {
                                                  return _c(
                                                    "span",
                                                    { key: index },
                                                    [
                                                      _c("img", {
                                                        staticClass: "img",
                                                        attrs: {
                                                          src: item.avatar,
                                                        },
                                                      }),
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            item.name || "- -"
                                                          ) +
                                                          "\n                      "
                                                      ),
                                                      scope.row.members &&
                                                      scope.row.members.length -
                                                        1 >
                                                        index
                                                        ? _c("span", [
                                                            _vm._v("、"),
                                                          ])
                                                        : _vm._e(),
                                                    ]
                                                  )
                                                }
                                              ),
                                              _vm._v(" "),
                                              scope.row.members &&
                                              scope.row.members.length == 0
                                                ? _c("span", [_vm._v("- -")])
                                                : _vm._e(),
                                            ],
                                            2
                                          ),
                                        ]
                                      ),
                                    ],
                                    2
                                  )
                                : _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        size: "small",
                                        multiple: "",
                                        filterable: "",
                                        "collapse-tags": "",
                                        placeholder: "指派协作者",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.changeMembers(
                                            scope.row,
                                            scope.$index
                                          )
                                        },
                                      },
                                      model: {
                                        value: _vm.membersId,
                                        callback: function ($$v) {
                                          _vm.membersId = $$v
                                        },
                                        expression: "membersId",
                                      },
                                    },
                                    _vm._l(
                                      _vm.programMemberOptions,
                                      function (item) {
                                        return _c("el-option", {
                                          key: item.id,
                                          attrs: {
                                            label: item.name,
                                            value: item.id,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "program",
                        label: "关联项目",
                        "min-width": "180",
                        "show-overflow-tooltip": "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-dropdown",
                                {
                                  attrs: {
                                    trigger: "click",
                                    placement: "bottom",
                                  },
                                  on: {
                                    command: function ($event) {
                                      return _vm.putProgramTask(
                                        "program_id",
                                        $event,
                                        scope.row.id
                                      )
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "pointer",
                                      on: {
                                        click: function ($event) {
                                          return _vm.isOperate(scope.row)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "el-tooltip",
                                        {
                                          staticClass: "item",
                                          attrs: {
                                            effect: "dark",
                                            placement: "top",
                                            "open-delay": 500,
                                            disabled: "",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "line1 members-line",
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    scope.row.program
                                                      ? scope.row.program.name
                                                      : "- -"
                                                  ) +
                                                  "\n                    "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "max-width": "180px",
                                              },
                                              attrs: { slot: "content" },
                                              slot: "content",
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    scope.row.program
                                                      ? scope.row.program.name
                                                      : "- -"
                                                  ) +
                                                  "\n                    "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-dropdown-menu",
                                    {
                                      attrs: { slot: "dropdown" },
                                      slot: "dropdown",
                                    },
                                    [
                                      scope.row.operate
                                        ? _c(
                                            "div",
                                            { staticClass: "fixed-height" },
                                            _vm._l(
                                              _vm.projectList,
                                              function (item, index) {
                                                return _c(
                                                  "el-dropdown-item",
                                                  {
                                                    key: index,
                                                    attrs: {
                                                      command: item.value,
                                                    },
                                                  },
                                                  [
                                                    _c("div", [
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(item.label)
                                                        ),
                                                      ]),
                                                      _vm._v(" "),
                                                      item.status == 1 ||
                                                      item.status == 2
                                                        ? _c(
                                                            "span",
                                                            {
                                                              class:
                                                                item.status == 1
                                                                  ? "program-stop"
                                                                  : "program-close",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.status ==
                                                                    1
                                                                    ? "已暂停"
                                                                    : "已关闭"
                                                                )
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]),
                                                  ]
                                                )
                                              }
                                            ),
                                            1
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "version",
                        label: "关联版本",
                        width: "100",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              !_vm.versionVisible[scope.$index]
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "pointer",
                                      on: {
                                        click: function ($event) {
                                          return _vm.showVersion(
                                            scope.row,
                                            scope.$index,
                                            1
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("span", { staticClass: "infos" }, [
                                        _vm._v(
                                          _vm._s(
                                            scope.row.version
                                              ? scope.row.version.name
                                              : "- -"
                                          )
                                        ),
                                      ]),
                                    ]
                                  )
                                : _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        size: "small",
                                        placeholder: "请选择关联版本",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.chooseVersion(
                                            scope.row,
                                            scope.$index
                                          )
                                        },
                                      },
                                      nativeOn: {
                                        click: function ($event) {
                                          return _vm.changeVersion(
                                            scope.row.program_id,
                                            scope.$index
                                          )
                                        },
                                      },
                                      model: {
                                        value: _vm.versionId,
                                        callback: function ($$v) {
                                          _vm.versionId = $$v
                                        },
                                        expression: "versionId",
                                      },
                                    },
                                    _vm._l(
                                      _vm.programVersionList,
                                      function (item) {
                                        return _c("el-option", {
                                          key: item.id,
                                          attrs: {
                                            label: item.name,
                                            value: item.id,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "plan_start",
                        label: "计划开始",
                        width: "160",
                        "header-align": "left",
                        "show-overflow-tooltip": "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              !_vm.startShowStates[scope.row.id]
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "pointer width100",
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleStartClick(scope.row)
                                        },
                                      },
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(scope.row.plan_start || "- -")
                                        ),
                                      ]),
                                    ]
                                  )
                                : _c("el-date-picker", {
                                    attrs: {
                                      size: "small",
                                      type: "date",
                                      clearable: "",
                                      format: "yyyy-MM-dd",
                                      "value-format": "yyyy-MM-dd",
                                      placeholder: "请选择项目计划开始日期",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.putProgramTask(
                                          "plan_start",
                                          $event,
                                          scope.row.id
                                        )
                                      },
                                      blur: function ($event) {
                                        return _vm.hideStartPicker(scope.row.id)
                                      },
                                    },
                                    model: {
                                      value: scope.row.plan_start,
                                      callback: function ($$v) {
                                        _vm.$set(scope.row, "plan_start", $$v)
                                      },
                                      expression: "scope.row.plan_start",
                                    },
                                  }),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "plan_end",
                        label: "计划结束",
                        width: "160",
                        "header-align": "left",
                        "show-overflow-tooltip": "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              !_vm.endShowStates[scope.row.id]
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "pointer width100",
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleEndClick(scope.row)
                                        },
                                      },
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(scope.row.plan_end || "- -")
                                        ),
                                      ]),
                                    ]
                                  )
                                : _c("el-date-picker", {
                                    attrs: {
                                      size: "small",
                                      type: "date",
                                      clearable: "",
                                      format: "yyyy-MM-dd",
                                      "value-format": "yyyy-MM-dd",
                                      placeholder: "请选择项目计划开始日期",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.putProgramTask(
                                          "plan_end",
                                          $event,
                                          scope.row.id
                                        )
                                      },
                                      blur: function ($event) {
                                        return _vm.hideEndPicker(scope.row.id)
                                      },
                                    },
                                    model: {
                                      value: scope.row.plan_end,
                                      callback: function ($$v) {
                                        _vm.$set(scope.row, "plan_end", $$v)
                                      },
                                      expression: "scope.row.plan_end",
                                    },
                                  }),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { prop: "creator", label: "创建人", width: "120" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("div", { staticClass: "pointer" }, [
                                scope.row.creator && scope.row.creator[0]
                                  ? _c("img", {
                                      staticClass: "img",
                                      attrs: {
                                        src: scope.row.creator[0]
                                          ? scope.row.creator[0].avatar
                                          : "",
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.creator
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          scope.row.creator[0]
                                            ? scope.row.creator[0].name
                                            : "- -"
                                        )
                                      ),
                                    ])
                                  : _vm._e(),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "plan_start",
                        label: "创建时间",
                        width: "160",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(_vm._s(scope.row.created_at || "- -")),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "plan_end",
                        label: "更新时间",
                        width: "160",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(_vm._s(scope.row.updated_at || "- -")),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.showDiv
                  ? _c(
                      "div",
                      { staticClass: "follow-div", style: _vm.divStyle },
                      [_vm._v("移动一个工作项")]
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "page-fixed" },
              [
                _c("el-pagination", {
                  attrs: {
                    "page-size": _vm.tableFrom.limit,
                    "current-page": _vm.tableFrom.page,
                    "page-sizes": [15, 20, 30],
                    layout: "total, sizes,prev, pager, next, jumper",
                    total: _vm.total,
                  },
                  on: {
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.pageChange,
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("addTask", {
        ref: "addTask",
        attrs: {
          projectList: _vm.projectList,
          programOptions: _vm.programOptions,
          programMemberOptions: _vm.programMemberOptions,
          programVersionList: _vm.programVersionList,
        },
        on: {
          getMemberList: _vm.getMemberList,
          getProgramVersionList: _vm.getProgramVersionList,
          getProgramSelectList: _vm.getProgramSelectList,
          getTableData: _vm.getTableData,
        },
      }),
      _vm._v(" "),
      _c("editTask", {
        ref: "editTask",
        attrs: {
          projectList: _vm.projectList,
          programOptions: _vm.programOptions,
          programMemberOptions: _vm.programMemberOptions,
          programVersionList: _vm.programVersionList,
        },
        on: {
          getMemberList: _vm.getMemberList,
          getProgramVersionList: _vm.getProgramVersionList,
          getProgramSelectList: _vm.getProgramSelectList,
          getTableData: _vm.getTableData,
          openTask: _vm.openTask,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }